/* global window */
window.document.addEventListener('DOMContentLoaded', () => {

});



// WEBPACK FOOTER //
// ./client/src/boot/index.js